import script from "./edit-appointment-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./edit-appointment-modal.vue?vue&type=script&setup=true&lang=ts"

import "./edit-appointment-modal.vue?vue&type=style&index=0&id=31cbc748&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31cbc748"]])

export default __exports__